import { Tag, Typography } from '@duxton-web/ui';
import { cpGetPersonas } from 'omega-rtc/actions/ucd';
import React from 'react';

import { localeSorter, personaFromApi } from './adapters';
import EntityListPage, { useEntityList } from './EntityListPage';

const columns = [
  {
    title: 'Variable',
    dataIndex: 'key',
    width: '40%',
    sorter: localeSorter('key'),
    render: (key) => <Tag>{key}</Tag>,
  },
  {
    title: 'Description',
    dataIndex: 'desc',
    render: (desc) => <Typography.Body level={2} type="secondary">{desc}</Typography.Body>,
  },
];

const PersonaPage = () => {
  const { data, loading } = useEntityList(
    cpGetPersonas, 'ucd.cpPersonas', 'requests.cpGetPersonasRequest', personaFromApi,
  );
  const sortedData = React.useMemo(() => [...data].sort(localeSorter('key')), [data]);
  return (
    <EntityListPage
      title="Persona Variables"
      rowKey="key"
      columns={columns}
      data={sortedData}
      loading={loading}
      emptyText="No persona variables defined."
    />
  );
};

export default PersonaPage;
